const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8083';


export async function fetchImageList(filter, token, onLogout) {
    const url = `${API_BASE}/v1/image-data/sample` + (filter ? `?filter=${filter}` : '');
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (res.status == 401) { onLogout(); }
    if (!res.ok) throw new Error('fetch failed');
    return res.json();
}


export async function fetchImageData(s3_path, token, onLogout) {
    const url = `${API_BASE}/v1/image-data?s3_path=${encodeURIComponent(s3_path)}`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (res.status == 401) { onLogout(); }
    if (!res.ok) throw new Error('fetch failed');
    return res.json();
}


export async function upsertLabel(s3_path, label, token, onLogout) {
    const url = `${API_BASE}/v1/image-data?s3_path=${encodeURIComponent(s3_path)}`;
    const res = await fetch(url, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ label }) });
    if (res.status == 401) { onLogout(); }
    if (!res.ok) throw new Error('update failed');
    return res.json();
}
